export default __webpack_public_path__ + "static/media/profileLoyalty.864ad8b9.svg";